// AnnouncementPopup.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // 1. useTranslation 훅 추가
import styles from './style/AnnouncementPopup.module.css';
import { Sparkles, BarChart2, TrendingUp, Rocket, X } from 'lucide-react';


function AnnouncementPopup({ onClose }) {
  const { t } = useTranslation(); // 2. 훅을 호출하고 t 함수를 가져옵니다.
  const [dontShowToday, setDontShowToday] = useState(false);

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button onClick={() => onClose(dontShowToday)} className={styles.closeButtonX}>
            <X size={20} />
        </button>

        <div className={styles.headerIcon}>
          <Sparkles size={48} />
        </div>

        {/* 3. t 함수를 사용해 텍스트를 번역 키로 교체합니다. */}
        <h3>
          {t('announcementPopup.newFeaturesTitle')}
        </h3>
        <p className={styles.subtitle}>
          {t('announcementPopup.subtitle')}
        </p>

        <div className={styles.featureList}>
          <div className={styles.featureItem}>
            <BarChart2 size={24} className={styles.featureIcon} />
            <div className={styles.featureText}>
              <h4>{t('announcementPopup.portfolioAnalysisTitle')}</h4>
              <p>{t('announcementPopup.portfolioAnalysisDesc')}</p>
            </div>
          </div>
          <div className={styles.featureItem}>
            <TrendingUp size={24} className={styles.featureIcon} />
            <div className={styles.featureText}>
              <h4>{t('announcementPopup.shareInsightsTitle')}</h4>
              <p>{t('announcementPopup.shareInsightsDesc')}</p>
            </div>
          </div>
        </div>

        <div className={styles.futureUpdate}>
          <div className={styles.visionBlock}>
            <Rocket size={20} className={styles.visionIcon} />
            <p>
              {t('announcementPopup.visionText')}
            </p>
          </div>
          <p className={styles.futureText}>
            {t('announcementPopup.futurePlanText')}
          </p>
        </div>

        <div className={styles.popupActions}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={dontShowToday}
              onChange={() => setDontShowToday(!dontShowToday)}
            />
            {t('announcementPopup.dontShowToday')}
          </label>
          <button onClick={() => onClose(dontShowToday)}>{t('announcementPopup.close')}</button>
        </div>
      </div>
    </div>
  );
}

export default AnnouncementPopup;